import React, { AriaAttributes, ReactChild } from 'react';
import './Card.less';
import classNames from 'classnames';
import { EnvagoAria } from '../../../aria.types';

const Card = ({
    children,
    className,
    onClick,
    onKeyDown,
    aria,
}: {
    children: ReactChild | ReactChild[] | Element[] | any | Element | string;
    className?: string;
    aria?: EnvagoAria;
    onClick?: () => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
}) => {
    return (
        <div onClick={onClick} onKeyDown={onKeyDown} className={classNames(className, { 'bg-gray-50': !className || className?.indexOf(' bg-') === -1 }, 'card')} {...aria}>
            {children}
        </div>
    );
};

export default Card;
